<script setup>
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  href: {
    type: String,
    default: null
  },
  to: {
    type: [String, Object],
    default: null
  }
});

const emit = defineEmits(['click']);

const handleClick = (event) => {
  if (props.disabled) {
    event.preventDefault();
    return;
  }
  emit('click', event);
};

const tag = props.href ? 'a' : props.to ? 'router-link' : 'button';
</script>

<template>
  <component
    :is="tag"
    :href="href"
    :to="to"
    class="ui-dropdown-item"
    :class="{
      'ui-dropdown-item--disabled': disabled
    }"
    @click="handleClick"
    :disabled="disabled && tag === 'button'"
  >
    <slot />
  </component>
</template>

<style scoped>
.ui-dropdown-item {
  align-items: center;
  width: calc(100% + 48px);
  padding: 8px 24px;
  margin: 0 -24px;
  box-sizing: border-box;
  border: none;
  background: transparent;
  color: #333;
  font-weight: 500;
  text-align: left;
  text-decoration: none;
  cursor: pointer;
  border-radius: 0;
  transition: all 0.15s ease-in-out;
  outline: none;

  &:hover:not(.ui-dropdown-item--disabled) {
    background-color: #d9f1fa;
    color: #333;
  }

  &:focus-visible {
    outline: 2px solid #ffc627;
    outline-offset: 2px;
  }
}

.ui-dropdown-item--disabled {
  cursor: not-allowed;
  opacity: 0.5;

  &:hover {
    background: transparent;
    color: #333;
  }
}
</style>
